<template lang="pug">
  .row.wrapper-spacing
    .small-12.columns(v-if="items.length")
      h1
        .spv-info-wrapper.info-trend Monatliche&nbsp;
          .info-overlay Wertentwicklung&nbsp;
            .info-overlay__icon: i.fo.icon-info_kreis
            .info-overlay__text {{ infoText[0] }}

        .spv-info-wrapper.text-only &nbsp;{{ indexName }} {{ month }}&nbsp;

        .spv-info-wrapper.info-trend
          span.text-normal mit Zielvolatilität&nbsp;
          .info-overlay
            span.text-normal {{ targetVol }}&nbsp;
            .info-overlay__icon: i.fo.icon-info_kreis
            .info-overlay__text {{ infoText[1] }}

      .spv-table-wrapper: table.spv-product-table.spv-index-table.spv-index-table--trend
        thead
          tr
            th.medium-8.large-9 Indexstichtag<br>{{ month === 'Juni' ? '01.06.' : '01.12.' }}{{ year }}
            th.medium-4.large-3: .spv-info-wrapper.flex-wrapper
              span Indexstand<br>jeweils am<br>Ende des Monats
              .info-overlay(v-if="indexId === 'trend'")
                .info-overlay__icon.header-info: i.fo.icon-info_kreis
                .info-overlay__text.right-aligned {{ infoText[2] }}

        tbody
          tr(v-for="(item, index) in items" :key="index")
            td {{ $parent.formatDate(item.date) }}
            td {{ $parent.formatMoney(item.index_value, 2) }}

        tfoot
          tr
            td.td-padding: .spv-info-wrapper Jahresrendite&nbsp;
              .info-overlay
                .info-overlay__icon: i.fo.icon-info_kreis
                .info-overlay__text.right-auto {{ infoText[3] }}
            td {{ $parent.formatPercent(yearlyYield, 2) }}

          tr
            td: .spv-info-wrapper Maßgebliche&nbsp;
              .info-overlay Jahresrendite&nbsp;
                .info-overlay__icon: i.fo.icon-info_kreis
                .info-overlay__text.right-auto {{ infoText[4] }}
            td {{ $parent.formatPercent(decisiveYield, 2) }}

      .row.pdf-button-wrapper.d-flex
        .small-6.columns.text-left
          a.button.button-small(v-if="factsheetPath && indexId === 'trend'" @click.stop="onOpenFactsheet()") Download Factsheet

        .small-6.columns.text-right
          a.button.button-small(@click="$emit('print')") Drucken

    .medium-12.large-12.columns(v-else)
      h1.no-margin Keine Monatswerte für {{ indexName }} für {{ month }} vorhanden.
      .text-left.mt-3(v-if="factsheetPath && indexId === 'trend'")
        a.button.button-small(@click.stop="onOpenFactsheet()") Download Factsheet

</template>

<script>
export default {
  name: 'index-trend-table',

  props: {
    items: {
      type: Array,
      default: () => []
    },

    indexId: {
      type: String,
      default: ''
    },

    indexName: {
      type: String,
      default: ''
    },

    month: {
      type: String,
      default: ''
    },

    year: {
      type: Number,
      default: 0
    },

    targetVol: {
      type: String,
      default: ''
    },

    yearlyYield: {
      type: Number,
      default: 0
    },

    decisiveYield: {
      type: Number,
      default: 0
    },

    factsheetPath: {
      type: [ Number, String ],
      default: ''
    },
  },

  data: () => ({
    infoText: [
      'Bisherige Wertentwicklungen liefern keinen Hinweis auf zukünftige Renditen.',
      'Die Höhe der Zielvolatilität wird jedes Jahr neu festgelegt. Rechtzeitig vor dem Indexstichtag informieren wir über die Höhe der Zielvolatilität für das nächste Jahr.',
      'Der Indexstand wird in Punkten angegeben (Basiswert sind 100 Punkte).',
      'Die Jahresrendite ist das Verhältnis des Kurses im aktuellen Monat zum Kurswert vor dem Indexstichtag. Positive und negative Wertentwicklungen fließen in den Index ein – es gibt keine Renditeobergrenze. Vor Vollendung des Jahres ist die angegebene Rendite unverbindlich.',
      'Die maßgebliche Jahresrendite ist das Verhältnis des Kurses am Ende des Indexjahres zum Kurswert vor dem Indexstichtag. Ist die Jahresrendite nicht positiv, wird die maßgebliche Jahresrendite auf 0 % gesetzt- Sie haben so kein Verlustrisiko des vorhandenen Kapitals.'
    ],
  }),

  methods: {
    onOpenFactsheet () {
      if (this.indexId === 'trend') {
        this.$emit('download-pdf', this.factsheetPath);
      } else {
        this.$emit('open-pdf', this.factsheetPath);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/apps/index/index-trend-table.vue